<template>
  <v-container fluid class="grey lighten-3">

    <v-row class="inner-content">
      <v-col>
        <NegativeKwListsTable />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'NegativeKwLists',

  components: {
    NegativeKwListsTable: () => import('@/components/tables/NegativeKwListsTable.vue')
  },
}
</script>
